// 



import api from "./instance";

export const getDoctors = (categories) =>
  api.get(
    "/admin/getdoctors",
    categories ? { params: { categories } } : {}
  );

export const getDoctorsByCategory = (categoryName) =>
  getDoctors(categoryName);

export const getDoctorSlots = (doctorId, date, type) => {
  const id =
    typeof doctorId === "object"
      ? doctorId?._id || doctorId?.id
      : doctorId;

  if (!id || !date) {
    return Promise.resolve({
      data: { date, slots: [] },
    });
  }

  return api.post(
    "/staff/doctor-slots",
    {
      doctorId: id,
    },
    {
      params: {
        date,
        type: type ? String(type).toLowerCase() : undefined,
      },
    }
  );
};

export const getDoctorBlogs = () => api.get("/doctor/blogs");
